module.exports = __webpack_public_path__ + "img/5.71be5412.png";